import type { ClientInitialOnboardingStatus } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { ONBOARDING_PARAMS } from '@/configs/version';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedAppApi } from '@/features/api/hooks/shared-app/useSharedAppApi';

export const useGetOnboardingStatusInitial = () => {
  const queryClient = useQueryClient();
  const api = useSharedAppApi();

  const select = useCallback(
    (status: ClientInitialOnboardingStatus) => {
      queryClient.setQueryData([API_CACHE_KEYS.LEGAL_TEXTS], status.legalTexts);
      queryClient.setQueryData([API_CACHE_KEYS.FEATURES], status.features);
      return status;
    },
    [queryClient]
  );

  return useQuery({
    queryKey: [API_CACHE_KEYS.ONBOARDING_STATUS_INITIAL, { ONBOARDING_PARAMS }],
    queryFn: () => api.getOnboardingStatusInitial(ONBOARDING_PARAMS),
    select
  });
};
